import React, { useState, useEffect, useRef, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaTrashAlt, FaUsers, FaSearch, FaPrint } from 'react-icons/fa';
import { format, subYears, addDays, isValid } from 'date-fns';
import MaskedInput from 'react-text-mask';
import Bunexe_service from '../../../Bunexe_service';
import Swal from 'sweetalert2';

// import 'react-datepicker/dist/react-datepicker.css';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
// import MaskedInput from 'react-text-mask';
// import PrintData9af from '../../PrintData9af';
import EditNotes from './EditNotes';
import DisplayInfoEleve from '../../DisplayInfoEleve';
import TestSalutation from './TestSalutation';
import { useHistory } from 'react-router-dom';
// import Bunexe_service from '../../../Bunexe_service';

const SaisieNotes = ({ ecole_selection, titre_ }) => {
  // const componentRef = useRef();
  const nomref = useRef();
  /** les variables */
  const [an9Af, setAn9Af] = useState('');
  const [mat9Af, setMat9Af] = useState('');
  const [moyns4, setMoyns4] = useState(0.0);
  const [note_ns3, setNote_ns3] = useState(0.0);
  const [info9Af, setInfo9Af] = useState([]);
  const [serie, setSerie] = useState(Bunexe_service.serie[1].Code_serie);
  const [rech_, setRech_] = useState('');
  let tt = '';
  let bloburl = '';
  const histo = useHistory();

  const entete = [
    {
      NOMEL: 'Nom',
      PRENOMEL: 'Prenom',
      SEXE: 'Sexe',
      DNAISS: 'Date Naiss.',
      an9AF: 'AN (9 A.F. )',
      mat9AF: 'Mat. (9 A.F.)',
      note: 'Note Fr.',
    },
  ];
  const [liste_eleve, set_Liste_eleve] = useState([]);
  let url_ = Bunexe_service.url;
  //'http://localhost:8086';

  const { Ecole } = ecole_selection;

  const formatterDate = (date__) => {
    try {
      return format(
        addDays(
          new Date(
            date__
              .substr(0, 4)
              .concat('-')
              .concat(date__.substr(4, 2))
              .concat('-')
              .concat(date__.substr(6, 2))
          ),
          1
        ),
        'dd/MM/yyyy'
      );
    } catch (error) {
      return 'N/A';
    }
  };

  const initChamp = () => {
    setMat9Af('');
    setNote_ns3('');
    set_Liste_eleve([]);
    setInfo9Af([]);
  };

  const getInfo9AF = async () => {
    try {
      fetch(url_ + `/recherche/9af_/${an9Af}/${mat9Af}`)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data);
          //setListe_ecole(data);
          setInfo9Af(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const supprimer = async (infoEleve) => {
    const requestOptions = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    };
    try {
      fetch(url_ + `/ns3_notes/delete_eleve/${infoEleve.id}`, requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            //  listeEleves_func(Ecole);

            reload_List();
            Swal.fire(
              'Supprime!',
              'Vous avez supprimé cet enregistrement avec succes.',
              'success'
            );
            //setShow(false);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error('Erreur de suppression ...', error);
    }
  };
  const listeEleves_func = async (Ecole) => {
    try {
      fetch(url_ + `/ns3_notes/${Ecole}`)
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          //setListe_ecole(data);
          set_Liste_eleve(data);
        })
        .catch((err) => console.log(err));
    } catch (error) {
      console.log(error);
    }
  };

  const reload_List = () => {
    listeEleves_func(Ecole);
  };

  const submitform = (e) => {
    e.preventDefault();
    if (note_ns3 > 8 && note_ns3 <= 100) {
      let Form_data = {
        an9Af,
        mat9Af,
        AN_encours: '1920',
        serie: serie,
        note: note_ns3,
        IDENTIFIANT: info9Af[0].IDENTIFIANT.trim(),
        CodeSiege: ecole_selection.CodeSiege,
        SESSION: 'O',
        Code_Ecole: ecole_selection.Ecole.trim(),
      };
      // alert(JSON.stringify(Form_data));
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Form_data),
      };
      try {
        fetch(url_ + '/ns3_notes/add_eleve', requestOptions)
          .then((response) => {
            return response.json();
            //else throw Error(response.statusText);
          })
          .then((data) => {
            if (data.hasError) {
              toast.error(data.message, {
                position: toast.POSITION.TOP_RIGHT,
              });
              //afficherMessage(data.message);
            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Enregistrement Sauvegardé.',
                showConfirmButton: false,
                timer: 1500,
              });
              listeEleves_func(Ecole);
              // resetForm();
              // nomref.focus();
            }
            // console.log(data);
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (error) {
        console.error("Erreur d'insertion ...", error);
      }
    } else {
      toast.error('La Note doit comprise entre 2 et 100', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    // alert(JSON.stringify(Form_data));
  };
  const myheader = {
    LibelleEt: ecole_selection.LibelleEt,
    AdresseEt: ecole_selection.AdresseEt,
    Ecole: ecole_selection.Ecole,
  };

  const printTable = () => {
    var doc = new jsPDF({ format: 'letter' });
    //let dd = districts_.filter((d) => d.CodeDistrict == district_);
    let pageHeight = 0;
    //console.log(JSON.stringify(dd));
    let mydata1 = liste_eleve.map((el) => {
      el.SEXE = el.SEXE == '1' ? 'M' : 'F';
      el.DNAISS = el.DNAISS && formatterDate(el.DNAISS);

      return el;
    });
    let mydata2 = [...mydata1];
    doc.setProperties({
      title: 'Impression Ecole ',
      subject: 'Liste des Inscrits',
      author: 'MENFP',
      keywords: 'menfp, bunexe',
      creator: 'BUNEXE',
    });

    var totalPagesExp = '{total_pages_count_string}';

    var pageHeight1 =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    let xOffset =
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
    let Tt =
      Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
      doc.internal.getFontSize();
    // let str = '';

    let r6 = mydata2.reduce((res, t) => {
      res[t.Libelle] = res[t.Libelle] ? [...res[t.Libelle], t] : [t];
      return res;
    }, []);
    let lignes = Object.keys(r6);
    doc.setFontSize(18);
    // doc.text('Dieu mon sujet de Gloire !!!', 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);

    // jsPDF 1.4+ uses getWidth, <1.4 uses .width
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    // var text = 'Je suis celui qui vit par la grace de Dieu'; //doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {})
    let str = '';
    // let pageHeight = 0;
    // doc.text(text, 14, 30);

    lignes.map((k) => {
      // doc.addPage();
      // doc.text(k + '  (' + r6[k][0].ecole + ')', 14, 30);
      // doc.text(r6[k][0].LibelleEt, 120, 30);
      // console.log(r6[k]);
      // doc.internal.
      doc.autoTable({
        head: entete,
        body: r6[k],
        startY: 56,
        showHead: 'everyPage',
        didDrawPage: function (data) {
          doc.setFontSize(20);
          // doc.setTextColor(100);
          doc.text(
            titre_.trim().toUpperCase(),
            pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 4.2) / 2,
            22
          );

          doc.text(
            ecole_selection.LibelleEt.trim(),
            pageWidth1 / 2 -
              (ecole_selection.LibelleEt.trim().length * 3.65) / 2,
            30
          );

          doc.text(
            ecole_selection.Ecole.trim(),
            pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
            38
          );

          doc.setFontSize(12);
          let An_ = 'Notes Anticipées (NS-III) (19-20) ';
          // doc.text(An_, pageWidth1 / 2 - (An_.length * 3.0) / 2, 46);
          doc.text(An_, 20, 48);

          // doc.setFontSize(14);
          // let Li_ = 'Liste des Inscrits';
          // doc.text(Li_, pageWidth1 / 2 - (Li_.length * 3.0) / 2, 52);

          let Lig_ =
            '______________________________________________________________';
          // doc.text(Lig_, pageWidth1 / 2 - (Lig_.length * 3.0) / 2, 50);
          doc.text(Lig_, 20, 50);

          doc.setFontSize(10);
          doc.text(k.trim(), 140, 48);

          doc.setFontSize(8);
          // dz = `District :${dd[0].libelle_district.trim()}  ==> Zone :${zon_}`;
          //doc.text(dz, pageWidth1 / 2 - (dz.length * 2.4) / 2, 36);
          //doc.text(dz, 150, 48);

          doc.setFontSize(11);

          // doc.text(
          //   ecole_selection.Ecole.trim(),
          //   pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
          //   38
          // );

          // doc.text(k, 14, 30);
          str = 'Page ' + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str =
              str +
              ' of ' +
              totalPagesExp +
              '     ===> Imprimé le ' +
              new Date().toISOString();
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
        },
        margin: { top: 44 },
      });
      doc.addPage();
    });
    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    tt = doc.output('blob');

    let blobPDF = new Blob([tt], { type: 'application/pdf' });
    bloburl = URL.createObjectURL(blobPDF);
    tt = bloburl;
    histo.push('/mat_anticipees/stat');
    //setMydoc(tt);
    //     let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    // width=0,height=0,left=-1000,top=-1000`;
    let params = `scrollbars=0,resizable=0,status=0,location=0,toolbar=0,menubar=0,
width=1200,height=600,left=200,top=120,status=0`;

    window.open(tt, 'Impression', params);
    //console.log(tt);
    // doc.text(text, 14, doc.autoTable.previous.finalY + 10);
    // document.getElementById('output').src = doc.output('datauristring');
    // document.getElementById('output').data = doc.output('datauristring');
  };

  /*
  const printTable = () => {
    var doc = new jsPDF({ orientation: 'landscape', format: 'legal' });
    var totalPagesExp = '{total_pages_count_string}';
    var pageHeight1 =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    let xOffset =
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
    let Tt =
      Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
      doc.internal.getFontSize();
    let str = '';
    let pageHeight = 11;
    let message_ = `${pageHeight1} === ${Tt} === ${titre_.length}`;
    // alert(message_);
    doc.autoTable({
      html: '#mytable',

      didDrawPage: function (data) {
        // Header
        doc.setFontSize(20);
        doc.setTextColor(40);
        doc.setFontStyle('normal');

        //doc.text(titre_, data.settings.margin.left + 15, 22);
        //doc.text(titre_, pageWidth1 / 2 - Tt / 2, 22);
        doc.text(
          titre_.trim().toUpperCase(),
          pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 4.2) / 2,
          22
        );
        doc.text(
          ecole_selection.LibelleEt.trim(),
          pageWidth1 / 2 - (ecole_selection.LibelleEt.trim().length * 3.65) / 2,
          30
        );

        doc.text(
          ecole_selection.Ecole.trim(),
          pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
          38
        );

        // Footer
        str = 'Page ' + doc.internal.getNumberOfPages();
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str =
            str +
            ' of ' +
            totalPagesExp +
            '     ===> Imprimé le ' +
            new Date().toISOString();
        }
        doc.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize;
        pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
      margin: { top: 44 },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    tt = doc.output('blob');

    let blobPDF = new Blob([tt], { type: 'application/pdf' });
    bloburl = URL.createObjectURL(blobPDF);
    tt = bloburl;
    //setMydoc(tt);
    //     let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
    // width=0,height=0,left=-1000,top=-1000`;
    let params = `scrollbars=0,resizable=0,status=0,location=0,toolbar=0,menubar=0,
width=1200,height=600,left=200,top=120,status=0`;

    //window.open(<TestSalutation />, 'Impression', params);
    window.open(tt, 'Impression', params);
    //console.log(tt);
  };
  */
  // setDefaultLocale('fr');
  useEffect(() => {
    listeEleves_func(Ecole);
    //nomref.current.focus();
  }, [liste_eleve.length]);

  return (
    <div className='container-fluid justify-content-center'>
      <div className='row mx-1'>
        <div className='col-xs-11 col-sm-11 col-md-4 col-lg-4 col-xl-4 border rounded py-3 '>
          <h3 className='text-center'>{ecole_selection.LibelleEt}</h3>
          <h5 className='text-center'>{ecole_selection.AdresseEt}</h5>
          <h6 className='text-center'>{ecole_selection.Ecole}</h6>
          <hr />

          <Form autoComplete='off' noValidate onSubmit={submitform}>
            <Form.Row>
              <Form.Group as={Col} controlId='formGridNom'>
                <Form.Label>Année 9 A.F</Form.Label>
                <MaskedInput
                  mask={[/\d/, /\d/, /\d/, /\d/]}
                  className='form-control'
                  placeholder='An 9 A.F'
                  value={an9Af}
                  ref={nomref}
                  name='an9Af'
                  guide={false}
                  onChange={(e) => setAn9Af(e.target.value)}
                />
                {/* <Form.Control
                  type='text'
                  placeholder='An 9 A.F'
                  value={an9Af}
                  ref={nomref}
                  name='an9Af'
                  // onFocus={(e) => listeEleves_func(Ecole)}
                  onChange={(e) => setAn9Af(e.target.value)}
                /> */}
              </Form.Group>

              <Form.Group as={Col} controlId='formGridPrenom'>
                <Form.Label>Matricule 9 A.F</Form.Label>
                <MaskedInput
                  mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                  className='form-control'
                  placeholder='Matricule 9 A.F'
                  value={mat9Af}
                  name='mat9Af'
                  onFocus={(e) => initChamp()}
                  onBlur={(e) => getInfo9AF()}
                  onChange={(e) => setMat9Af(e.target.value)}
                  guide={true}
                />
                {/* <Form.Control
                  type='text'
                  placeholder='Matricule 9 A.F'
                  value={mat9Af}
                  name='mat9Af'
                  onBlur={(e) => getInfo9AF()}
                  onChange={(e) => setMat9Af(e.target.value)}
                /> */}
              </Form.Group>
            </Form.Row>
            <hr />
            {info9Af.length > 0 && <DisplayInfoEleve d={info9Af[0]} ph='nt' />}
            <hr />
            {info9Af.length > 0 && parseInt(info9Af[0].Moy) >= 5 && (
              <>
                {/* <Form.Row>
                  <Form.Group as={Col} controlId='formGridPrenom'>
                    <Form.Label>
                      Moyenne NS I ou Troisième Secondaire
                    </Form.Label>
                    <Form.Control
                      type='number'
                      placeholder='Moyenne'
                      value={moyns4}
                      max='9.99'
                      name='moyns4'
                      onChange={(e) => setMoyns4(e.target.value)}
                    />
                  </Form.Group>
                </Form.Row> */}
                <Form.Row>
                  <Form.Group as={Col} controlId='formSerie'>
                    <Form.Label>Serie</Form.Label>
                    <Form.Control
                      as='select'
                      value={serie}
                      onChange={(e) => {
                        setSerie(e.target.value);
                      }}
                    >
                      {Bunexe_service.serie.map((s) => (
                        <option value={s.Code_serie}>{s.Libelle}</option>
                      ))}
                      {/* <option value='M'>Masculin</option> */}
                      {/* <option value='F'>Feminin</option> */}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group as={Col} controlId='formGridPrenom'>
                    <Form.Label>Note Français NS-III</Form.Label>
                    <Form.Control
                      type='number'
                      placeholder='Note '
                      value={note_ns3}
                      max='99'
                      name='note_ns3'
                      onChange={(e) => setNote_ns3(e.target.value)}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Button
                    className='btn-block'
                    style={{ marginTop: '20px', marginBottom: '10px' }}
                    variant='primary'
                    type='submit'
                  >
                    Ajouter
                  </Button>
                </Form.Row>
              </>
            )}
          </Form>
          <hr />
        </div>
        <div className='col-xs-11 col-sm-11 col-md-8 col-lg-8 col-xl-8'>
          {/* <ReactToPrint
            trigger={() => (
              <button className='btn btn-small btn-primary'>Imprimer</button>
            )}
            content={() => componentRef.current}
          /> */}
          {/* <h2 className='text-center'>Affichage des Donnees --{date_naiss}</h2> */}

          {liste_eleve && liste_eleve.length > 0 && (
            // <PrintData9af
            //   ref={componentRef}
            //   myheader={myheader}
            //   mydata_={liste_eleve}
            // />
            <Fragment>
              {/* <div className='d-flex justify-content-between'>
                <button
                  className='btn btn-small btn-primary'
                  onClick={printTable}
                >
                  Imprimer
                </button>
                <span className='text-right mx-auto'>
                  {liste_eleve.length} -{' Enregistrements'}
                </span>
              </div>
              */}
              <div className='d-flex justify-content-between mt-2'>
                <div>
                  <div className='input-group'>
                    <button
                      className='btn btn-small btn-primary mr-2'
                      onClick={printTable}
                    >
                      <FaPrint size={20} />
                    </button>

                    {/* <AfficheImpression mydoc={tt} /> */}
                    <input
                      type='text'
                      className='form-control'
                      placeholder='Recherche par nom...'
                      value={rech_}
                      onChange={(e) => setRech_(e.target.value)}
                      aria-label='Username'
                      aria-describedby='basic-addon1'
                    />
                    <div className='input-group-append'>
                      <span className='input-group-text' id='basic-addon1'>
                        <FaSearch />
                      </span>
                    </div>
                  </div>
                </div>
                <span>
                  <span
                    className='badge badge-dark px-3 font-weight-bolder'
                    style={{ fontSize: '20px' }}
                  >
                    {liste_eleve.length}
                  </span>
                  <FaUsers className='mx-1' size={20} />
                  {/* {' Enregistrements'} */}
                </span>
              </div>

              <div
                style={{
                  height: '500px',
                  overflowY: 'scroll',
                  scrollbarWidth: 'thin',
                }}
              >
                <table className='table table-striped' id='mytable'>
                  <thead>
                    {/* <tr>
                    <th colSpan='8'>
                      <h2 className='text-center'>{myheader.LibelleEt}</h2>
                      <h4 className='text-center'>{myheader.AdresseEt}</h4>
                      <h6 className='mx-auto'>{myheader.Ecole}</h6>
                    </th>
                  </tr> */}

                    <tr>
                      {/* <th>Identifiant</th> */}
                      <th>Nom</th>
                      <th>Prenom</th>
                      <th>Sexe</th>
                      <th>Date Naissance</th>
                      {/* <th>Ecole</th> */}
                      <th>Serie</th>
                      <th>Note Fr.</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {liste_eleve
                      .filter((f) =>
                        rech_.length == 0
                          ? true
                          : f.NOMEL.toUpperCase().includes(
                              rech_.toUpperCase()
                            ) ||
                            f.PRENOMEL.toUpperCase().includes(
                              rech_.toUpperCase()
                            )
                      )
                      .map((el) => (
                        <tr key={el.IDENTIFIANT}>
                          {/* <td>{el.Identifiant}</td> */}
                          <td>{el.NOMEL}</td>
                          <td>{el.PRENOMEL}</td>
                          <td>{el.SEXE}</td>
                          <td>
                            {format(
                              addDays(
                                new Date(
                                  el.DNAISS.substr(0, 4)
                                    .concat('-')
                                    .concat(el.DNAISS.substr(4, 2))
                                    .concat('-')
                                    .concat(el.DNAISS.substr(6, 2))
                                ),
                                1
                              ),
                              'dd/MM/yyyy'
                            )}
                            {/* {el.DNAISS} */}
                          </td>
                          {/* <td>{el.Ecole_ns4}</td> */}
                          <td>{el.Libelle}</td>
                          <td>{el.note}</td>
                          <td>
                            <span className='px-1 mx-2'>
                              <EditNotes
                                infoEleve={el}
                                myheader={myheader}
                                reload_List={reload_List}
                              />
                              |{' '}
                              <FaTrashAlt
                                onClick={(e) =>
                                  Swal.fire({
                                    title: `Voulez-vous vraiment supprimer ${el.Nom} ${el.Prenom} dont l'identifiant est :${el.Identifiant} ?`,
                                    icon: 'danger',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Oui, je le veux!',
                                  }).then((result) => {
                                    if (result.value) {
                                      supprimer(el);
                                    }
                                  })
                                }
                              />
                            </span>
                            |
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default SaisieNotes;
